import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';

import { WarningModal } from './WarningModal.tsx';

export const i18n: {
	strictFormatModalTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	strictFormatModalBody: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	strictFormatModalTitle: {
		id: 'import-from-sources.warning-modal.strictFormatModalTitle',
		defaultMessage: 'File format not supported',
		description: 'Message in modal header indicating that files format not supported',
	},
	strictFormatModalBody: {
		id: 'import-from-sources.warning-modal.strictFormatModalBody',
		defaultMessage:
			'The .docx file imported was saved as a Strict Open XML. Please save it as Word Document .docx and import again.',
		description:
			'Message in modal body indicating the steps how to resave the file as Word Document .docx',
	},
});

export const StrictFormatModal: React.FC<{
	onSubmit: () => void;
	onClose: () => void;
}> = ({ onSubmit, onClose }) => {
	return (
		<WarningModal
			onSubmit={onSubmit}
			onClose={onClose}
			headText={<FormattedMessage {...i18n.strictFormatModalTitle} />}
			bodyText={<FormattedMessage {...i18n.strictFormatModalBody} />}
		/>
	);
};
